<div class="bottom_sticky p-2 d-flex gap-16 align-items-center justify-content-end">
 <span class="material-icons-outlined pointer font-18 lightGray"
       [ngClass]="{'pointer-ev-none lightGray2': page == 1}"
       (click)="toChangePage('previous')">arrow_back_ios</span>

  <div class="w-10">
    <mat-form-field class="w-100">
      <mat-select disableRipple [(ngModel)]="perPage" (ngModelChange)="changePerPage($event)">
        <mat-option value="{{value}}" *ngFor="let value of perPageArray">{{ value }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>


  <small class="lightGray2">
    Page {{ page }}
    <span *ngIf="maxPage">/ {{ maxPage }}</span>
  </small>

  <span class="material-icons-outlined pointer font-18 lightGray"
        [ngClass]="{'pointer-ev-none lightGray2': !hasMore}"
        (click)="toChangePage('next')">arrow_forward_ios</span>
</div>
